module.exports = __webpack_public_path__ + "static/media/posline.b12724f3.svg";